// extracted by mini-css-extract-plugin
module.exports = {"fakeLink":"SignOutForm_fakeLink__8VCn-","signInAs":"SignOutForm_signInAs__1Zw7j","button":"SignOutForm_button__2DWij"};